(function() {
    "use strict";

    var controller = function($scope, commonTLCService,TLCError,AppErrorCodes){

        $scope.model = $scope.model || "";

        commonTLCService.getStates()
            .then(function (response) {
                $scope.states = response;
            }, function (response) {
                throw new TLCError(new Error(response),AppErrorCodes.Global_Unknown);
            });
    };

    var directive = function factory() {
        return {
            templateUrl: 'app/modules/web/directives/state-dropdown-directive.html',
            replace: true,
            transclude: false,
            restrict: 'E',
            controller: ['$scope', 'commonTLCService', controller],
            scope: {
                model: "=?",
                onClose: "&?",
                disabled: "=?"
            }
        };
    };

    webModule.directive('stateDropdown', directive);

}());
